import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#5471d2",
      main: "#0d46a0",
      dark: "#002071",
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#ffb45",
      main: "#fb8c00",
      dark: "#c25e00",
      contrastText: "#000000",
    },
  },
});

export default theme;
